import type { FeAnagraficaSu_FeAnagraficheTemplate, FeOrders_FeOrders } from '#public_ts/commons/dbs-shared';

declare let window: any;

export type PriceTier = {
    q: number;
    p: number;
};

export type PriceModel = {
    qty_min?: number;
    prices: PriceTier[];
    price_fixed?: number;
    mode: string;
    handler?: string;
    handlerparams?: unknown[];
};

export type PaymentMethodConfig = {
    epr?: string;
};

export type PaymentsConfig = {
    paypal?: PaymentMethodConfig;
    gestpay?: PaymentMethodConfig;
};

const ERR: unknown = window.ERR;
const PRICE_TABLE: { price_model?: PriceModel } = window.PRICE_TABLE;
const ORDER: FeOrders_FeOrders | undefined = window.ORDER;
const ORDER_START_TIME: string | undefined = window.ORDER_START_TIME;
const STYLE: string = window.STYLE;
const PAYMENTS: PaymentsConfig = window.PAYMENTS;
const AnagraficaTemplates: FeAnagraficaSu_FeAnagraficheTemplate[] = window.AnagraficaTemplates;

export {
    AnagraficaTemplates,
    ERR,
    ORDER,
    ORDER_START_TIME,
    PAYMENTS,
    PRICE_TABLE,
    STYLE,
};
